import { SVGProps } from "react"
const ImageUploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" {...props}>
    <g
      fill="none"
      stroke="#b1b8c3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      data-name="Group 18843"
    >
      <path d="M12 14.5c-2.5 0-6.25 1.25-6.25 6.25" data-name="Path 6033" />
      <path
        d="M.75 12a2.5 2.5 0 0 1 2.5-2.5H9.5A2.5 2.5 0 0 1 12 12v6.25a2.5 2.5 0 0 1-2.5 2.5H3.25a2.5 2.5 0 0 1-2.5-2.5Z"
        data-name="Path 6034"
      />
      <path d="M.75 4.5V2A1.25 1.25 0 0 1 2 .75h2.5" data-name="Path 6035" />
      <path d="M9.5.75H12" data-name="Path 6036" />
      <path d="M17 .75h2.5A1.25 1.25 0 0 1 20.75 2v2.5" data-name="Path 6037" />
      <path d="M20.75 9.5V12" data-name="Path 6038" />
      <path
        d="M20.75 17v2.5a1.25 1.25 0 0 1-1.25 1.25H17"
        data-name="Path 6039"
      />
    </g>
  </svg>
)
export default ImageUploadIcon
